module.exports = __webpack_public_path__ + "img/check-item.1f5f3063.svg";